import ReactOnRails from 'react-on-rails';

import App from './components/App/index';
import BaseUIButton from './components/BaseUI/Button/index';
import BaseUICustomToaster from './components/BaseUI/CustomToaster/index';
import BaseUILinkCopy from './components/BaseUI/LinkCopy/index';
import Clipper from './components/Clipper';
import CorporateLanding from './components/CorporateLanding/index';
import CorporateSubscriberCircleContainer from './components/Partners/CorporateSubscriberCircleContainer';
import CryptoPowerlist from './components/CryptoPowerlist/index';
import EmailConfirmation from './components/shared/EmailConfirmation/index';
import EnableProfileModal from './components/shared/EnableProfileModal/index';
import EnterprisePowerlist from './components/EnterprisePowerlist/index';
import Event from './components/Event/index';
import EventFollowBanner from './components/Event/EventFollowBanner/index';
import FeaturedPartnerContainer from './components/Partners/FeaturedPartnerContainer';
import FollowButtonWithQueryClientWrapper from './components/shared/FollowButton/FollowButtonWithQueryClientWrapper';
import Gift from './components/Gift/index';
import LockedLeadCaptureForm from './components/shared/LockedLeadCaptureForm/index';
import LockedLeadCaptureFormMarketingLeadCaptureWithGoogle from './components/shared/LockedLeadCaptureForm/MarketingLeadCaptureWithGoogle';
import MarketingModal from './components/MarketingModal/index';
import Nav from './components/Nav/index';
import NewsletterFeedBanner from './components/Newsletter/NewsletterFeedBanner/index';
import OnboardingModal from './components/OnboardingModal/index';
import OrgSignUp from './components/OrgSignUp/index';
import ProExclusiveLogo from './components/shared/ProExclusiveLogo/index';
import ProMarketingCTAs from './components/Pro/ProMarketingCTAs';
import ReferralLanding from './components/Referral/Landing/index';
import ReferralSubscription from './components/Referral/Subscription/index';
import SearchPage from './components/SearchPage/index';
import SettingsUserProfile from './components/Settings/UserProfile/index';
import ShareNav from './components/ShareNav/index';
import SocialLinks from './components/shared/SocialLinks/index';
import Subscribe from './components/Subscribe/index';
import SubscriptionTeam from './components/Subscription/Team/index';
import SubscriptionLanding from './components/SubscriptionLanding/index';
import Team from './components/Team';
import TIHeader from './components/TIHeader';
import TopicDescription from './components/Topic/TopicDescription/index';
import TopicFollowAndTagModal from './components/Topic/TopicFollowAndTagModal/index';
import TopicForumPosts from './components/Forum/TopicForumPosts/index';

ReactOnRails.register({
  App,
  BaseUIButton,
  BaseUICustomToaster,
  BaseUILinkCopy,
  Clipper,
  CorporateLanding,
  CorporateSubscriberCircleContainer,
  CryptoPowerlist,
  EmailConfirmation,
  EnableProfileModal,
  EnterprisePowerlist,
  Event,
  EventFollowBanner,
  FeaturedPartnerContainer,
  FollowButtonWithQueryClientWrapper,
  Gift,
  LockedLeadCaptureForm,
  LockedLeadCaptureFormMarketingLeadCaptureWithGoogle,
  MarketingModal,
  Nav,
  NewsletterFeedBanner,
  OnboardingModal,
  OrgSignUp,
  ProExclusiveLogo,
  ProMarketingCTAs,
  ReferralLanding,
  ReferralSubscription,
  SearchPage,
  SettingsUserProfile,
  ShareNav,
  SocialLinks,
  Subscribe,
  SubscriptionTeam,
  SubscriptionLanding,
  Team,
  TIHeader,
  TopicDescription,
  TopicFollowAndTagModal,
  TopicForumPosts
})
